module.exports = __webpack_public_path__ + "img/list.492b457c.svg";